export default __webpack_public_path__ + "static/media/torso-top-back.54decb8e.png";